import { render, staticRenderFns } from "./SubscriptionTable.vue?vue&type=template&id=473bdb66"
import script from "./SubscriptionTable.vue?vue&type=script&lang=ts"
export * from "./SubscriptionTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports